<template>
  <div v-if="callOut" class="pl-1 pr-2 py-2 bg-racq-blue justify-start items-center gap-0.5 inline-flex rounded-t-sm">
    <span class="bg-icon-star icon w-4 h-4 bg-no-repeat bg-contain"></span>
    <div class="text-xs-bold text-racq-true-white uppercase">{{ callOut }}</div>
  </div>
  <RadioCardListItem
    :label="label"
    :help="help"
    :image="image"
    :isSelected="isSelected"
    :rightLabel="rightLabel"
    :rightHelp="rightHelp"
    :hideCheckbox="hideCheckbox"
    :isMega="!!visibleBody"
  />
  <div v-if="visibleBody" class="pl-4 pr-8 pb-2 text-left">
    <RichText :field="{ value: visibleBody }" class="text-racq-med-grey text-base richtext" />
    <RichText v-if="showMore" :field="{ value: hiddenBody }" class="text-racq-med-grey text-base richtext" />
    <ShowHideButton v-if="hiddenBody" :showMore="showMore" :disabled="disabled" @click="showMore = !showMore" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import ShowHideButton from '@/components/ShowHideButton/ShowHideButton.vue';
import RadioCardListItem from './RadioCardListItem.vue';

defineProps<{
  label: string;
  help?: string;
  image?: ImageField;
  isSelected: boolean;
  disabled?: boolean;
  rightLabel?: string;
  rightHelp?: string;
  hideCheckbox?: boolean;
  callOut?: string;
  visibleBody?: string;
  hiddenBody?: string;
}>();

const showMore = ref(false);
</script>
